<template>
  <div>
    <!-- : '任务结果预览' -->
    <el-dialog :title="$t('message.taskResultPreview')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="460px" center>
      <div class="content">
        <!-- 是否异常 -->
        <div class="label">
          {{ $t('message.isAbnormal') }}:
        </div>
        <div class="isAbnormal">
          <span style="color:#15AD3C" v-if="itemData.execute_abnormal == 1">无异常</span>
          <span style="color:#B4272D" v-if="itemData.execute_abnormal == 2">有问题</span>
        </div>
        <!-- 图片记录 -->
        <div class="label">
          {{ $t('message.imageRecords') }}:
        </div>
        <div class="imageRecords">
          <div class="item" v-for="(image, imageIndex) in itemData.image" :key="imageIndex">
            <el-image style="width: 80px; height: 80px;margin-right: 6px;" :src="image" :preview-src-list="[image]">
            </el-image>
          </div>
        </div>
        <!-- 备注记录 -->
        <div class="label">
          {{ $t('message.remarkRecords') }}:
        </div>
        <div class="remarkRecords">
          <el-input v-model="itemData.deal_remark" disabled type="textarea"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确定 -->
        <el-button type="primary" @click="dialogVisible = false">
          {{ $t("message.ok") }}
        </el-button>
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    itemData: { type: Object }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.content {
  .label {
    margin-bottom: 6px;
  }

  .isAbnormal {
    background: #F8F8F8;
    border-radius: 4px;
    width: 380px;
    border: 1px solid #DCDFE6;
    padding: 10px;
    margin-bottom: 24px;
  }

  .imageRecords {
    display: flex;
    flex-wrap: wrap;

    .item {
      margin: 0 20px 20px 0;

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .remarkRecords {
    /deep/.el-textarea__inner {
      height: 150px !important;
      resize: none;
      background: #F8F8F8 !important;

    }
  }
}
</style>